import(/* webpackMode: "eager" */ "/Users/oneshubh/satyam/SocialGraphs/node_modules/next/font/google/target.css?{\"path\":\"src/app/(settings-layout)/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/AuthRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/BottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/LeftSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/SettingsComponent.tsx");
